<template>
  <div class="file">
    <div class="grid-row grid-row_sm d-flex_wrap">
      <div class="grid-col pt-8" v-for="(image, i) in images" :key="image">
        <div class="file__preview border-radius-md bg-fill-dark-soft">
          <img class="img-cover" :src="image" alt="" />
          <div
            class="file__delete btn color-gray hover-color-dark"
            @click="removeImage(i)"
          >
            <Icon iconName="icon-close" className="icon-16" />
          </div>
        </div>
      </div>
      <div class="grid-col pt-8">
        <label class="file__button btn border-radius-md">
          <input
            type="file"
            multiple
            class="file__input"
            accept="image/*"
            @change="onFileChange"
          />
          <Icon iconName="icon-camera" className="icon-28" />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";

export default {
  name: "File",
  components: {
    Icon,
  },
  data() {
    return {
      images: [],
    };
  },
  setup() {
    const storeReviews = useReviewsStore();

    return {
      storeReviews,
    };
  },
  methods: {
    onFileChange(e) {
      this.createImages(e.target.files || e.dataTransfer.files);
    },
    createImages(files) {
      [...files].forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.images.push(e.target.result);
          this.storeReviews.reviewInProcess.files.push(e.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
    removeImage(index) {
      this.images.splice(index, 1);
      this.storeReviews.reviewInProcess.files.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
@import "./file.scss";
</style>
